import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'
import s from './OutOfStockSubscription.scss'


class OutOfStockSubscription extends PureComponent {

  static contextTypes = {
    close: PropTypes.func,
  }

  render() {
    const { close } = this.context

    return (
      <div onClick={close}>
        <Box pl="96" relative className={s.item}>
          <div className={s.img} />
          <Box mb="4">
            <Text size="14-24" uppercase semibold message={messages.title} html />
          </Box>
          <Box mb="4">
            <Text message={messages.text} html size="12-16" />
          </Box>
        </Box>
      </div>
    )
  }
}


export default OutOfStockSubscription
